import { Card, Skeleton } from "antd";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import HTTP from "../../services/httpService";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";

const columns = [
    {
        title: "Ticket Id",
        dataIndex: "id",
        key: "id",
        sorter: () => {},
    },
    {
        title: "Project",
        dataIndex: "project_name",
        key: "project_name",
        sorter: () => {},
    },
    {
        title: "Key",
        dataIndex: "ticket_key",
        key: "ticket_key",
        sorter: () => {},
    },
    {
        title: "Type Of Issue",
        dataIndex: "issue_type",
        key: "issue_type",
        sorter: () => {},
    },
    {
        title: "Priority",
        dataIndex: "priority",
        key: "priority",
        sorter: () => {},
    },
    {
        title: "Assignee",
        dataIndex: "assignee_name",
        key: "assignee_name",
        sorter: () => {},
    },
    {
        title: "Created By",
        dataIndex: "creator_name",
        key: "creator_name",
        sorter: () => {},
    },
    {
        title: "Status",
        dataIndex: "status",
        key: "status",
        sorter: () => {},
    },
];

function TicketsByPriorityTable() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const { priority: priority_id } = useParams();
    const [ticketData, setTicketData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [formData, setFormData] = useState({
        staff_id,
        priority_id,
        limit: 10,
        page: 0,
    });

    const {
        status: jiraPriorityTicketStatus,
        data: jiraPriorityTicketRes,
        refetch: fetchPriorityTickets,
    } = useQuery(
        "jiraPriorityTicketTable",
        async () => {
            return await HTTP("/analytics/getPriorityTickets", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        fetchPriorityTickets();
    }, []);

    useEffect(() => {
        fetchPriorityTickets();
    }, [formData]);

    useEffect(() => {
        if (jiraPriorityTicketStatus === "success") {
            const { data: tableData, total } = jiraPriorityTicketRes;
            setTicketData(tableData);
            setTotalRecords(total);
        }
    }, [jiraPriorityTicketStatus, jiraPriorityTicketRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        } else {
            delete formData.sorting;
            delete formData.sort_by;
        }
        const updatedFormData = { ...formData, ...others };
        setFormData(updatedFormData);
    }

    return (
        <>
            <Card className="dashboard-container">
                <CustomHeader />
                {!ticketData.length ? (
                    <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 20, width: 40 }}
                    />
                ) : (
                    <CustomTable
                        columns={columns}
                        tableData={ticketData}
                        noOfrecords={totalRecords}
                        handleTableChange={handleTableChange}
                        rowKey="id"
                        className="dashboard-table"
                    />
                )}
            </Card>
        </>
    );
}

export { TicketsByPriorityTable };
